/* This is generated code, don't alter */
var IfcTransformerTypeEnum;
(function (IfcTransformerTypeEnum) {
    IfcTransformerTypeEnum[IfcTransformerTypeEnum["CURRENT"] = 0] = "CURRENT";
    IfcTransformerTypeEnum[IfcTransformerTypeEnum["FREQUENCY"] = 1] = "FREQUENCY";
    IfcTransformerTypeEnum[IfcTransformerTypeEnum["INVERTER"] = 2] = "INVERTER";
    IfcTransformerTypeEnum[IfcTransformerTypeEnum["RECTIFIER"] = 3] = "RECTIFIER";
    IfcTransformerTypeEnum[IfcTransformerTypeEnum["VOLTAGE"] = 4] = "VOLTAGE";
    IfcTransformerTypeEnum[IfcTransformerTypeEnum["USERDEFINED"] = 5] = "USERDEFINED";
    IfcTransformerTypeEnum[IfcTransformerTypeEnum["NOTDEFINED"] = 6] = "NOTDEFINED";
})(IfcTransformerTypeEnum || (IfcTransformerTypeEnum = {}));
const IfcTransformerTypeEnumCount = 7;
export { IfcTransformerTypeEnum, IfcTransformerTypeEnumCount };
/* This is generated code, don't alter */
import MinimalPerfectHash from "../../indexing/minimal_perfect_hash.js";
let gMapIfcTransformerTypeEnum = new Int32Array([495]);
let prefixSumAddressIfcTransformerTypeEnum = new Uint32Array([0, 9, 18, 29, 42, 53, 65, 75]);
let slotMapIfcTransformerTypeEnum = new Int32Array([0, 4, 3, 5, 1, 6, 2]);
let encodedDataIfcTransformerTypeEnum = (new TextEncoder()).encode(".CURRENT..VOLTAGE..RECTIFIER..USERDEFINED..FREQUENCY..NOTDEFINED..INVERTER.");
let IfcTransformerTypeEnumSearch = new MinimalPerfectHash(gMapIfcTransformerTypeEnum, prefixSumAddressIfcTransformerTypeEnum, slotMapIfcTransformerTypeEnum, encodedDataIfcTransformerTypeEnum);
export { IfcTransformerTypeEnumSearch };
/* This is generated cold, don't alter */
import StepEnumParser from "../../step/parsing/step_enum_parser.js";
const parser = StepEnumParser.Instance;
export function IfcTransformerTypeEnumDeserializeStep(input, cursor, endCursor) {
    return parser.extract(IfcTransformerTypeEnumSearch, input, cursor, endCursor);
}
